import type { FaireProductEntity } from "../../entity_types/product";

export const p_rvjb2rmhjt: FaireProductEntity = {
  token: "p_rvjb2rmhjt",
  type: "product",
  name: "Staying At Home Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/cd581e937e37ffbd5c2a2620af48aba857d1e6f88fe2ad32942c2842a083e7f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c2ea4f4a8fef663855519818d406abbf458ed9c59d090bcffff3f5e28594e98c.jpeg",
    "https://cdn.faire.com/fastly/723bfa13e574431dfcc723d1fcf53907fef815c30fafad2c32340259fa2d124a.jpeg",
    "https://cdn.faire.com/fastly/79a77c65f45eee911c362775c901d56f294e9408a101f20342480e1c7ff15b84.jpeg"
  ],
  priceDollars: 8.5,
  description: "A ready to hang metal tin sign from our Slow Living Collection displaying a hand illustrated design of a cozy dining table with a fun sentiment that reads \"Staying At Home Does Count As A Plan\" perfect for those who enjoy cozy home life. Cozy living sign features metal with embossed details for added dimension. Our Staying At Home metal wall décor is easy to hang against wall using the included mounting hardware and pre-drilled holes. A cozy living home accent that easily adds personality to any space.",
  tags: [],
  msrpDollars: 16.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:26.070Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
